import OBase from './OBase';
import * as Geometry from '../geometry';

export default class Orient extends OBase {
  update () {
    let geomInputTree = this.getSolidObjectInput('Geometry');
    let sourceTree = this.getPlaneInput('Source', false);
    let targetTree = this.getPlaneInput('Target', false);

    let output = this.outputs['Geometry'].paramObject;
    let dataTrees = [geomInputTree, sourceTree, targetTree];
    let outDataTrees = [];

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let geomInput = outDataTrees[0].branches[i][j];
        let sourcePlane = outDataTrees[1].branches[i][j];
        let targetPlane = outDataTrees[2].branches[i][j];

        let m1 = new THREE.Matrix4();
        m1.lookAt(sourcePlane.center, sourcePlane.center.clone().add(new THREE.Vector3(0, 1, 0)), sourcePlane.normal);
        // m1.lookAt(sourcePlane.center, sourcePlane.center.clone().add(sourcePlane.yAxis), sourcePlane.normal)
        let q1 = new THREE.Quaternion();
        q1.setFromRotationMatrix(m1);

        let m2 = new THREE.Matrix4();
        m2.lookAt(targetPlane.center, targetPlane.center.clone().add(targetPlane.yAxis), targetPlane.normal);
        let q2 = new THREE.Quaternion();
        q2.setFromRotationMatrix(m2);

        let quat = new THREE.Quaternion();
        quat.multiplyQuaternions(q2, q1.inverse());

        let g;
        if (geomInput instanceof THREE.Geometry) {
          g = geomInput.clone();
          g.vertices.forEach(v => {
            v.set(v.x - sourcePlane.center.x, v.y - sourcePlane.center.y, v.z - sourcePlane.center.z);
            v.applyQuaternion(quat);
            v.set(v.x + targetPlane.center.x, v.y + targetPlane.center.y, v.z + targetPlane.center.z);
          });
        } else if (geomInput instanceof Array) {
          // Orient ClipperLib.Path
          g = geomInput.map(path => {
            return path.map(p => {
              let v = new THREE.Vector3(p.X, p.Y, 0);
              v.set(v.x - sourcePlane.center.x, v.y - sourcePlane.center.y, v.z - sourcePlane.center.z);
              v.applyQuaternion(quat);
              v.set(v.x + targetPlane.center.x, v.y + targetPlane.center.y, v.z + targetPlane.center.z);
              return new ClipperLib.DoublePoint(v.x, v.y);
            });
          });
        } else {
          console.warn('invalid geom input', geomInput);
        }

        outTree.add(g, outDataTrees[0].paths[i]);
      }
    }

    output.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Orient.js